/**
 * @param object
 * @returns A new object where each key of the object is in lowercase
 */
export const lowercaseKeys = (object: any): any =>
  Object.fromEntries(
    Object.entries(object).map(([k, v]) => [k.toLowerCase(), v])
  );
